import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { formRequiredRules } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputRadio } from 'sharedComponents/inputGroup/InputRadio';
import { Lead } from '../LeadGenInterface';
import { VEHICLE_TYPE } from '../LeadGenConstant';
import { postLeadCreation } from 'store/LeadCreationState';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const VehicleSelection: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // React Hook Form Trigger
  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { vehicleType } = getValues();

    const vehicleTypeData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Vehicle Type': vehicleType,
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: vehicleTypeData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.(0);
  };

  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <>
      <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.vehicleSelTxt')}</h3>
      <InputRadio
        rules={formRequiredRules(errorMessage(t).radioError)}
        name={'vehicleType'}
        control={control}
        options={VEHICLE_TYPE(t)}
        directionRow={false}
        itemPerRow={{
          xs: 12,
          sm: 6,
        }}
        triggerValidationForField={(name: string) => {
          trigger(name);
          onNext?.();
        }}
        radioVariant='outline-with-icon'
      />
    </>
  );
};

const VehicleSelectionStep = React.forwardRef(VehicleSelection);

export default VehicleSelectionStep;
